module.exports = {
    env: process.env.NODE_ENV,
    api: process.env.VUE_APP_API,
    iconCollection: process.env.VUE_APP_ICON_COLLECTION_1,
    iconDefault: process.env.VUE_APP_ICON_DEFAULT_1,
    mediaServer: process.env.VUE_APP_MEDIA_SERVER,
    statsServer: process.env.VUE_APP_STATS_SERVER,
};
